export function openIndexedDBWithRecovery(
  dbName: string,
  storeName: string,
  version: number
): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, version);

    request.onupgradeneeded = function () {
      const db = request.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: "id" });
      }
    };

    request.onsuccess = function () {
      const db = request.result;

      if (!db.objectStoreNames.contains(storeName)) {
        db.close();
        alert("Please try again after the refresh.");

        const deleteRequest = indexedDB.deleteDatabase(dbName);

        deleteRequest.onsuccess = function () {
          window.location.reload();
        };

        deleteRequest.onerror = function () {
          reject(
            new Error(`Failed to delete corrupted DB: ${deleteRequest.error}`)
          );
        };

        deleteRequest.onblocked = function () {
          reject(
            new Error("Cannot delete DB because another tab is using it.")
          );
        };

        return;
      }

      resolve(db);
    };

    request.onerror = function () {
      reject(request.error);
    };
  });
}
